// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useQuery } from '@tanstack/react-query';
import { useHttpClient, type HttpClientInstance } from '@toggl/sync/http';
import type {} from '../types';
import { createQueryOptions } from '../utils/queries';
import { getMeQueryKey } from './keys';
import { getMe } from './requests';

/**
 * Returns the authenticated user's profile, workspace list (with roles/trials), and related flags.
 */
export function getMeQueryOptions(
  httpClient: HttpClientInstance,
  enabled?: boolean
) {
  return createQueryOptions({
    queryKey: getMeQueryKey(),
    queryFn: ({ signal }) => getMe(httpClient, signal),
    enabled,
  });
}
/**
 * Returns the authenticated user's profile, workspace list (with roles/trials), and related flags.
 */
export function useGetMe(enabled?: boolean) {
  const httpClient = useHttpClient();
  return useQuery(getMeQueryOptions(httpClient, enabled));
}
